import React from 'react'

import HandThumbUpIcon from '../../../assets/icons/hand-thumb-up.svg?react'
import Button from '../form/Button'
import TextArea from '../form/TextArea'
import { useI18N } from '../../../libraries/i18n/hook'
import { UserFeedback } from '../../../api/user-feedback/types'
import { ANALYTICS_EVENTS, useAnalytics } from '../../../libraries/posthog'

type Props = { onSubmit:  (data: UserFeedback) => Promise<void>, iconColor?: string }
const UserFeedbackForm: React.FC<Props> = ({ onSubmit, iconColor = 'black' }) => {
  const { t } = useI18N()
  const [showForm, setShowForm] = React.useState(false)
  const [sentiment, setSentiment] = React.useState<boolean>(false)
  const [content, setContent] = React.useState<string>('')
  const formRef = React.useRef<HTMLFormElement>(null)
  const { trackEvent } = useAnalytics()

  const handleShowForm = (sentiment: boolean) => {
    setShowForm(true)
    setSentiment(sentiment)

    // Force scroll to form after it's rendered
    setTimeout(() => {
      formRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      })
    }, 0)
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    trackEvent(ANALYTICS_EVENTS.AI_FEEDBACK, { sentiment, content })
    await onSubmit({ content, sentiment })
  }

  const handleCancel = (e: React.MouseEvent) => {
    e.preventDefault()
    setShowForm(false)
    setContent('')
  }

  return (
    <>
      <Button icon={<HandThumbUpIcon className={`stroke-${iconColor}`} />} size='md' variant='flat' onClick={() => handleShowForm(true)} />
      <Button icon={<HandThumbUpIcon className={`stroke-${iconColor} rotate-180`} />} size='md' variant='flat' onClick={() => handleShowForm(false)} />
      {showForm && (
        <form ref={formRef} onSubmit={handleSubmit} className='w-full bg-gray-300 rounded-md p-3'>
          <TextArea rows={3} value={content} onChange={e => setContent(e.target.value)} placeholder={sentiment ? t('ai.user.positive.feedback.placeholder') : t('ai.user.negative.feedback.placeholder')}/>
          <div className='gap-x-4 flex justify-end mt-1'>
            <Button variant='secondary' outlined size='sm' onClick={handleCancel}>{t('common.cancel')}</Button>
            <Button variant='primary' size='sm' className='min-w-[120px]'>{t('common.send')}</Button>
          </div>
        </form>
      )}
    </>
  )
}

export default UserFeedbackForm
